/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LineWithDot/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LineWithDot({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/MedicalFormSelector/Content/Form/LineWithDot"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let formItemIsLastValueData = fromData.useDataFormat({ viewPath,
context: 'form_item',
path: 'isLast',
format: fromFormat.not,
})
  return (<React.Fragment
>
<div
  data-testid="LineWithDot.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z12TKcR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="LineWithDot.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-Z12TKcR': dtColorsNeutral300,'--bc-3-Z12TKcR': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical1}`}
/>
<fromFlow.When is={formItemIsLastValueData}>
<div
  data-testid="LineWithDot.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-2-Z12TKcR': dtColorsNeutral300}}
 className={`views-block ${styles.Vertical2}`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}